import { ILocale } from '@move-frontend/contentful-routes';
import { contentful } from '../../../shared/api/contentful';
import { LOYALTY_TIER_TYPE_ID } from '../../../shared/api/contentful/constants';
import {
	ILoyaltyTier,
	ILoyaltyTierEntry,
} from '../../../shared/api/contentful/types/ILoyaltyTier';

export async function getLoyaltyTiers({
	locale,
}: {
	locale?: ILocale;
}): Promise<ILoyaltyTier[]> {
	const loyaltyTiers = await contentful()
		.entry<ILoyaltyTierEntry>(LOYALTY_TIER_TYPE_ID)
		.getAll({
			locale: locale?.code,
		});

	return loyaltyTiers.map((loyalty) => loyalty.fields);
}
